import { render } from "./WeCare.vue?vue&type=template&id=55a657c4&scoped=true"
import script from "./WeCare.vue?vue&type=script&lang=ts"
export * from "./WeCare.vue?vue&type=script&lang=ts"

import "./WeCare.vue?vue&type=style&index=0&id=55a657c4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55a657c4"

export default script